import { render } from "./university.vue?vue&type=template&id=290ab406&scoped=true"
import script from "./university.vue?vue&type=script&lang=js"
export * from "./university.vue?vue&type=script&lang=js"

import "./university.vue?vue&type=style&index=0&id=290ab406&scoped=true&lang=css"

import exportComponent from "/Users/basil/Documents/rishad/ncp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-290ab406"]])

export default __exports__